// store/slices/projectManagement/user-detail-view/UserDetailModalSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface UserDetailModalState {
    data: {
        userId: string | null;
        open: boolean;
        activeTab?: string;
        extra?: {
            projectId?: number;
            projectName?: string;
        };
    };
}

const initialState: UserDetailModalState = {
    data: {
        userId: null,
        open: false,
        activeTab: "masters",
    },
};

const UserDetailModalSlice = createSlice({
    name: "UserDetailModal",
    initialState,
    reducers: {
        updateUserDetailModalSlice(
            state,
            action: PayloadAction<{
                userId: string;
                open: boolean;
                activeTab?: string;
                extra?: { projectId?: number; projectName?: string };
            }>
        ) {
            state.data = {
                ...state.data,
                ...action.payload,
            };
        },
        resetUserDetailModalSlice(state) {
            state.data = initialState.data;
        },
    },
});

export const { updateUserDetailModalSlice, resetUserDetailModalSlice } =
    UserDetailModalSlice.actions;
export default UserDetailModalSlice;